let landingAPISetting: null | boolean = null;

export const setEnableLongDescription = (value: boolean) => {
  landingAPISetting = value;
};

export const enableLongDescription = () => !!landingAPISetting;
